import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=1fa7bef6&scoped=true"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7bef6",
  null
  
)

export default component.exports